import { render, staticRenderFns } from "./AssetThumbItem.vue?vue&type=template&id=2bf7c309"
import script from "./AssetThumbItem.vue?vue&type=script&lang=js"
export * from "./AssetThumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports